import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  list: {
    width: 380,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: '88vw',
      // maxWidth: '100%',
    },
  },
  fullList: {
    width: 'auto',
  },
  navIconShowDesktop: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
  },
  submenuTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    margin: '0.5rem',
  },
  authButton: {
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    borderRadius: '20px !important',
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
}));

export default useStyles;
